import MiranaState from './mirana-state';
import {UserDetails} from '../api/mirana-api';
import {mirana} from '@wize/mirana-proto/mirana-proto';

export default class MiranaStateEditor {

    public state: MiranaState;
    private rawState: any;
    private isMutated: boolean = false;

    public constructor(state: MiranaState) {
        this.state = state;
        this.rawState = state.getRawState();
    }

    public setIsAuthenticated(isAuthenticated: boolean) {
        if (this.state.getIsAuthenticated() !== isAuthenticated) {
            this.rawState.isAuthenticated = isAuthenticated;
            this.isMutated = true;
        }
    }

    public setIsLoading(isLoading: boolean) {
        this.rawState.isLoading = isLoading;
        this.isMutated = true;
    }

    public setUserDetails(userDetails: UserDetails) {
        if (this.state.getUserDetails() !== userDetails) {
            this.rawState.userDetails = userDetails;
            this.isMutated = true;
        }
    }

    public setCarteraDetalle(fuerzaVentaId: string, detalle: mirana.CarteraDetalle) {
        const detalles = this.state.getCarterasDetalles() ? new Map(this.state.getCarterasDetalles()) : new Map<string, mirana.CarteraDetalle>();
        detalles.set(fuerzaVentaId, detalle);
        this.rawState.carterasDetalles = detalles;
        this.isMutated = true;
    }

    public commit(): MiranaState {
        return this.isMutated ? new MiranaState(this.rawState) : this.state;
    }
}



// WEBPACK FOOTER //
// ./src/reduxstore/mirana-state-editor.ts